import { render, staticRenderFns } from "./RolesTable.vue?vue&type=template&id=62383900&scoped=true"
import script from "./RolesTable.vue?vue&type=script&lang=js"
export * from "./RolesTable.vue?vue&type=script&lang=js"
import style0 from "./RolesTable.vue?vue&type=style&index=0&id=62383900&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62383900",
  null
  
)

export default component.exports